var map = {
	"./Schneider Placement.jpeg": 7176,
	"./adwik.jpeg": 50952,
	"./bahwancybertec.jpg": 68065,
	"./calibrant.jpg": 87693,
	"./crobotp.jpeg": 89959,
	"./cse-deloitte.jpeg": 22846,
	"./datacorp.jpeg": 4194,
	"./delta-eee.jpg": 44135,
	"./delta-eie.jpeg": 97092,
	"./delta-eie1.jpeg": 60163,
	"./eee-zoho.jpg": 19507,
	"./ignitarium.jpg": 73982,
	"./itc-eee.jpg": 29319,
	"./jgc-eie.jpeg": 44318,
	"./kasadara.jpeg": 20152,
	"./mallowtech.jpg": 59501,
	"./mrcooper.jpeg": 26139,
	"./nbase2syatem.jpeg": 60730,
	"./presidio.jpeg": 87201,
	"./rently.jpeg": 71138,
	"./valeo.jpeg": 15401,
	"./workhall.jpg": 15331,
	"./zoho-eie.jpg": 67167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71213;